import { Component, OnInit, ViewChild } from '@angular/core';
import {fromEvent} from 'rxjs'
import { PlansCardComponent } from '../plans-card/plans-card.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlansChecklistComponent } from '../plans-checklist/plans-checklist.component';

@Component({
  selector: 'app-plans-dashboard',
  templateUrl: './plans-dashboard.component.html',
  styleUrls: ['./plans-dashboard.component.css']
})
export class PlansDashboardComponent implements OnInit {
  
  isfoodplan :boolean = false;
  isactivityplan :boolean = false;
  isdashboard : boolean = true;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  @ViewChild(PlansChecklistComponent) checklist : PlansChecklistComponent;
  
  constructor(private logCard: PlansCardComponent,
    private breakpointObserver: BreakpointObserver) { 
    
    fromEvent(window, 'popstate')
    .subscribe((e) => {
     console.log(e, 'back button');
    });
    this.isfoodplan = false;
    this.isactivityplan = false;
    this.isdashboard = true;
    console.log("in dashboard constructor");
  }

  ngOnInit() {
    console.log("in dashboard init");
  }

  changeTab(event) {
    console.log("in change tab");
    if (event.index == 0) {
      this.goToChecklist();
    } else if (event.index == 1) {
      this.goToFoodPlan();
    } else {
      this.goToActivityPlan();
    }
  }

  goToChecklist() {
    this.checklist.pullFoodPlans();
    this.checklist.pullActivityPlans();
  }

  goToFoodPlan() {
    this.isfoodplan = !this.isfoodplan;
    this.isdashboard = false;
   }

  goToActivityPlan() {
    this.isactivityplan = !this.isactivityplan;
    this.isdashboard = false;
   }
  

  goToDashBoard($event){
    console.log("going to dashboard");
    if ($event == "saved")
    this.isfoodplan = false;
    this.isactivityplan = false;
    this.isdashboard = true;
  }
}